/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createSkillRequestSchema = z.object({
  critical: z.boolean(),
  name: z.string().min(1),
});
